export class SkinData {
    constructor() {
        this.slotArr = [];
    }
}
